// extracted by mini-css-extract-plugin
export var activeDot = "_2i-c";
export var buttonContainer = "_2i-9";
export var channelButton = "_2i-a";
export var clickable = "_2i-d";
export var content = "_2i-0";
export var contentFull = "_2i-2";
export var contentThird = "_2i-1";
export var contentWrapper = "_2i-7";
export var description = "_2i-5";
export var heightShort = "_2i-f";
export var image = "_2i-3";
export var imageContainer = "_2i-4";
export var selectButton = "_2i-e";
export var spinnerContainer = "_2i-b";
export var titleContent = "_2i-8";
export var titleWrapper = "_2i-6";